import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getProductById({ commit, state }, { id }) {
    try {
      let product = (state.products || []).find((p) => p.id === id);
      if (!product) {
        let response = await requestAxios({
          url: `/awy/api/v1/ecommerce/product/${id}`,
          method: "GET",
        });
        product = response.data.data;
      }
      commit(MutationsType.SET_PRODUCT, product);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllProducts({ commit }, payload) {
    try {
      let params = {};

      if (payload?.orderBy) params.orderBy = payload.orderBy;
      if (payload?.storeId) params.storeId = payload.storeId;

      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/product",
        method: "GET",
        params: params,
      });

      commit(MutationsType.SET_PRODUCTS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveProduct({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/product",
        method: "POST",
        data: payload,
      });
      commit(MutationsType.ADD_PRODUCT, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateProduct({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/product/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_PRODUCT, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteProduct({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/ecommerce/product/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.DELETE_PRODUCT, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetProduct({ commit }) {
    commit(MutationsType.SET_PRODUCT, null);
  },
  resetModuleCatalogProduct({ commit }) {
    commit(MutationsType.SET_PRODUCT, null);
    commit(MutationsType.SET_PRODUCTS, null);
  },
};
